export default {
  DROPDOWN: 'dropdown',
  TEXT:     'text',
  NUMBER:   'number',
  DATE:     'date',
};
